/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Marked_TitleInputs */

const en_us2_workout_quick_marked_title = /** @type {(inputs: Workout_Quick_Marked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't remember the details?`)
};

const pt_br2_workout_quick_marked_title = /** @type {(inputs: Workout_Quick_Marked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não lembra os detalhes?`)
};

const es_419_workout_quick_marked_title = /** @type {(inputs: Workout_Quick_Marked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No recuerdas los detalles?`)
};

const pt_pt2_workout_quick_marked_title = /** @type {(inputs: Workout_Quick_Marked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não te lembras dos detalhes?`)
};

const fr_fr2_workout_quick_marked_title = /** @type {(inputs: Workout_Quick_Marked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu ne te souviens plus des détails ?`)
};

const de_de2_workout_quick_marked_title = /** @type {(inputs: Workout_Quick_Marked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details vergessen?`)
};

const it_it2_workout_quick_marked_title = /** @type {(inputs: Workout_Quick_Marked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ricordi i dettagli?`)
};

/**
* | output |
* | --- |
* | "Don't remember the details?" |
*
* @param {Workout_Quick_Marked_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_marked_title = /** @type {((inputs?: Workout_Quick_Marked_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Marked_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_marked_title(inputs)
	if (locale === "es-419") return es_419_workout_quick_marked_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_marked_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_marked_title(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_marked_title(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_marked_title(inputs)
	return en_us2_workout_quick_marked_title(inputs)
});
export { workout_quick_marked_title as "workout-quick.marked_title" }